module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "language-switch"
  }, _vm._l((_vm.i18n), function(lang) {
    return _c('li', {
      class: {
        'active': lang.active
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.setLanguage(lang.key)
        }
      }
    }, [_vm._v(_vm._s(lang.display))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47896149!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageSwitch.vue
// module id = 35
// module chunks = 1 2 3 4 5 6